var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "hx-template-container" },
        [
          _c("el-header", { staticClass: "hx-template-header" }, [
            _c("div", { staticClass: "hx-logo" }, [
              _c("img", {
                attrs: { src: "static/images/logo-small.png", alt: "" },
              }),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.headerLoading,
                    expression: "headerLoading",
                  },
                ],
                staticClass: "headerMain",
              },
              [
                _c(
                  "el-menu",
                  {
                    attrs: {
                      "default-active": _vm.state.menuActive,
                      mode: "horizontal",
                      router: "",
                    },
                    on: { select: _vm.select },
                  },
                  [
                    _vm._l(_vm.menu, function (item) {
                      return _c("el-menu-item", {
                        key: item.path,
                        attrs: { index: item.path },
                        domProps: { textContent: _vm._s(item.name) },
                      })
                    }),
                    _vm.stadiumHeader.length > 0
                      ? _vm._l(_vm.stadiumHeader, function (item, index) {
                          return _c(
                            "el-submenu",
                            { key: index, attrs: { index: item.stadiumUrl } },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(_vm._s(item.stadiumTitle)),
                              ]),
                              _vm._l(_vm.submenuItem[index], function (val) {
                                return _c("el-menu-item", {
                                  key: val.path,
                                  attrs: { index: val.path },
                                  domProps: { textContent: _vm._s(val.name) },
                                })
                              }),
                            ],
                            2
                          )
                        })
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "hx-template-header-right" }, [
                  _c("p", { staticClass: "hx-account align-center" }, [
                    _vm._v(_vm._s(_vm.username)),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "login-out-style",
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-back" }),
                      _c("span", [_vm._v("退出登录")]),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-container",
            { staticStyle: { height: "100%" } },
            [
              _c(
                "el-aside",
                { staticClass: "hx-template-aside" },
                [
                  _vm.sideBar
                    ? _c(
                        "el-menu",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.sideLoading,
                              expression: "sideLoading",
                            },
                          ],
                          staticClass: "hx-aside-menu",
                          attrs: {
                            "unique-opened": true,
                            "default-active": _vm.$route.path,
                            router: "",
                          },
                          on: { select: _vm.select },
                        },
                        _vm._l(_vm.sideBar, function (item, index) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              _vm.sideBar[index].sub.length > 0
                                ? _c(
                                    "el-submenu",
                                    {
                                      key: item.name,
                                      attrs: { index: item.path },
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(_vm._s(item.name)),
                                      ]),
                                      _vm._l(item.sub, function (val) {
                                        return _c(
                                          "el-menu-item",
                                          {
                                            key: val.index,
                                            attrs: { index: val.path },
                                          },
                                          [_vm._v(_vm._s(val.name))]
                                        )
                                      }),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm.sideBar[index].sub.length === 0
                                ? _c(
                                    "el-menu-item",
                                    {
                                      key: item.name,
                                      attrs: { index: item.path },
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(_vm._s(item.name)),
                                      ]),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-main",
                { staticClass: "hx-template-main" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in", appear: "" } },
                    [_c("router-view")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-login-out-template",
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("h3", { staticClass: "align-center" }, [
            _vm._v("确认退出服务加？"),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.linkToLoginPage },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("PwdUpdate", {
        attrs: { dialogVisible: _vm.dialogVisiblePwd },
        on: {
          "update:dialogVisible": function ($event) {
            _vm.dialogVisiblePwd = $event
          },
          "update:dialog-visible": function ($event) {
            _vm.dialogVisiblePwd = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }